import { Component } from '@angular/core';
import { SideMenuComponent } from '../../side-menu/side-menu.component';
import { ProductNavbarComponent } from "../product-navbar/product-navbar.component";
import {MatTabsModule} from '@angular/material/tabs';
import { NgStyle } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-housing-loan',
  standalone: true,
  imports: [SideMenuComponent, ProductNavbarComponent, MatTabsModule, NgStyle, TranslateModule],
  templateUrl: './housing-loan.component.html',
  styleUrl: './housing-loan.component.css'
})
export class HousingLoanComponent {

  baseApiUrl = environment.baseApiUrl;

  tabs = [
    { label: 'Product Features', content: 'Product Features' },
    { label: 'Benefits', content: 'Benefits' },
    { label: 'Requirements', content: 'Requirements' },
    { label: 'How to Apply', content: 'How to Apply' }
  ];

  getTabBorderWidth(label: string): string {
      // Calculate the border width based on the label length
      return (label.length * 2) + 'px'; // Adjust the multiplier for desired width
  }
}
